import React from 'react';


export function UnitSuccess() {
  return (
    <div>
      <p>Enheten är nu tillagd</p>
    </div>
  );
}